import { List, ListSubheader } from "@mui/material";
import { IFilterProps } from "../../interfaces";
import PeriodoFilter from "./periodo";

function PeriodoFiltersContainer({ filters, setFilters }: IFilterProps) {
  return (
    <List
      dense={true}
      sx={{ p: 0 }}
      component="nav"
      subheader={<ListSubheader component="div">Periodo</ListSubheader>}
    >
      <PeriodoFilter filters={filters} setFilters={setFilters} />
    </List>
  );
}

export default PeriodoFiltersContainer;
